/**
 * Created by kocsmarb on 2018.06.26..
 */

import DataSheet from './components/DataSheet';
import Search from './components/Search/Search';
import SearchForm from './components/Search/Custom/SearchForm';
import HandlebarsExtension from './components/HandlebarsExtension';
import Suggestion from './components/Suggestion';
import Slider from './components/Slider';
import PageParameters from './components/PageParameters';

(function (global, $) {
    var NNP = global.NNP = global.NNP || {};
    new HandlebarsExtension(Handlebars);
    Handlebars.registerHelper('replace', function (find, replace, options) {
        var string = options.fn(this);
        return string.replace(find, replace);
    });
    Handlebars.registerHelper('dateIsCorrect', function (date) {
        return date !== '1000-01-01' && date !== '';
    })

    Handlebars.registerHelper('datesIsCorrect', function (date1, date2) {
        return date1 !== '1000-01-01' && date1 !== '' && date2 !== '1000-01-01' && date2 !== '';
    })

    NNP.SearchForm = SearchForm;
    NNP.Search = Search;
    NNP.DataSheet = DataSheet;
    NNP.Suggestion = Suggestion;
    NNP.Slider = Slider;
    NNP.PageParameters = PageParameters;

    var customMapHandler = function ( $scope, $ ) {
        var marker,
            mapElem = $scope.find( '.pp-google-map' ).eq( 0 ),
            locations = mapElem.data( 'locations' ),
            zoom = ( mapElem.data( 'zoom' ) !== '' ) ? mapElem.data( 'zoom' ) : 7,
            zoomType = ( mapElem.data( 'zoomtype' ) !== '' ) ? mapElem.data(
                'zoomtype' ) : 'auto',
            mapOptions = '',
            i = '',
            entityCoordinates;

        ( function initMap() {
            if ( !! document.getElementById( 'daddr' ) ) {
                entityCoordinates = JSON.parse(
                    '[' + document.getElementById( 'daddr' ).value + ']' );
                locations[ 0 ] = entityCoordinates;
            }

            function getComponentName( needle, haystack ) {
                var filteredResults = haystack.filter( function ( result ) {
                    return !! result.address_components.filter(
                        function ( component ) {
                            return component.types.includes( needle );
                        } ).length;
                } );

                if ( ! filteredResults.length ) {
                    return null;
                }

                var filteredComponent = filteredResults[ 0 ].address_components.filter(
                    function ( component ) {
                        return component.types.includes( needle );
                    } );

                if ( ! filteredComponent.length ) {
                    return null;
                }

                return filteredComponent[ 0 ].long_name;
            }

            function geocodeLatLng( geocoder, map, pos ) {
                geocoder.geocode( { location: pos } )
                    .then( function ( response ) {
                        if ( ! response.results[ 0 ] ) {
                            window.alert( 'No results found' );
                            return;
                        }
                        map.setZoom( 11 );

                        var components = [
                            'country',
                            'administrative_area_level_1|administrative_area_level_2',
                            'postal_code',
                            'sublocality|locality',
                            'route',
                            'street_number'
                        ];

                        var customFormat = components.map( function ( e ) {
                            var result, i = 0, needles = e.split( '|' );
                            while ( needles[ i ] && ! result ) {
                                result = getComponentName( needles[ i ],
                                    response.results );
                                i++;
                            }
                            return result;
                        } );

                        $( '#form-field-location_details' )
                            .val( customFormat.filter( Boolean ).join( ', ' ) );
                    } )
                    .catch( function ( e ) {
                        return window.alert( 'Geocoder failed due to: ' + e );
                    } );
            }

            function setMarker( pos ) {
                if ( typeof marker === 'undefined' ) {
                    marker = new google.maps.Marker( {
                        position: pos, map: map
                    } );
                } else {
                    marker.setPosition( pos );
                }
                map.panTo( pos );
                geocodeLatLng(geocoder, map, pos);
                $( '#form-field-coordinates' ).val( pos.lng + ' ' + pos.lat );
            }

            var latlng = new google.maps.LatLng( locations[ 0 ][ 0 ],
                locations[ 0 ][ 1 ] );
            mapOptions = {
                zoom: zoom,
                center: latlng,
                mapTypeId: 'roadmap',
                mapTypeControl: true,
                streetViewControl: true,
                zoomControl: true,
                fullscreenControl: true,
                gestureHandling: 'auto',
                draggableCursor: ''
            };

            var map = new google.maps.Map( $scope.find( '.pp-google-map' )[ 0 ],
                mapOptions ), bounds = new google.maps.LatLngBounds();
            var geocoder = new google.maps.Geocoder();

            if ( !! entityCoordinates ) {
                marker = new google.maps.Marker( {
                    position: {
                        lat: locations[ 0 ][ 0 ], lng: locations[ 0 ][ 1 ]
                    }, map: map
                } );
            }

            const locationButton = document.createElement("i");

            locationButton.title = 'Koordináták megadása helymeghatározással';
            locationButton.classList.add( 'fa-solid', 'fa-crosshairs' );
            map.controls[ google.maps.ControlPosition.LEFT_BOTTOM ].push(
                locationButton );
            locationButton.addEventListener( 'click', function () {
                // Try HTML5 geolocation.
                if ( navigator.geolocation ) {
                    navigator.geolocation.getCurrentPosition(
                        function ( position ) {
                            var pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            };
                            setMarker( pos );
                        } );
                } else {
                    // Browser doesn't support Geolocation
                }
            } );

            map.addListener( 'click', function ( e ) {
                setMarker(e.latLng.toJSON());
            } );

            for ( i = 0; i < locations.length; i++ ) {
                var lat = locations[ i ][ 0 ], lng = locations[ i ][ 1 ];
                if ( lat.length !== '' && lng.length !== '' ) {
                    if ( 'auto' === zoomType ) {
                        var loc = new google.maps.LatLng( lat, lng );
                        bounds.extend( loc );
                        map.fitBounds( bounds );
                    }
                }
            }
        } )();
    };

    $( document )
        .on( 'elementor/popup/show', function () {
            elementorFrontend.hooks.addAction(
                'frontend/element_ready/pp-google-maps.default',
                customMapHandler );
            if ( !! document.getElementById( 'form-field-coordinates' ) ) {
                $( '#map_hint' ).parent()
                    .after( $( '#suggestion_coordinates_map' ) );
            }
        } )
        .on( 'focus', '.dialog-widget input, .dialog-widget select',
            function () {
                var suggestionMap = $( '#suggestion_coordinates_map' );
                var mapHint = $('#map_hint');
                if ( document.activeElement.id === 'form-field-coordinates' ) {
                    mapHint.toggle(true);
                    suggestionMap.slideDown();
                } else {
                    mapHint.toggle(false);
                    suggestionMap.slideUp();
                }
        } );
    $( 'input[name="namespace"]' ).focus();

})(window, jQuery);
